import {toast} from '@wandb/weave/common/components/elements/Toast';
import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import {Tooltip} from '@wandb/weave/components/Tooltip';
import {ApolloQueryResult} from 'apollo-client';
import React, {useState} from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Input} from 'semantic-ui-react';

import {
  EntityQuery,
  useUpdateEntityAdminMutation,
} from '../../generated/graphql';

type EntityRateLimitInputProps = {
  originalLimit: number;
  entityName: string;
  limitTitle: string;
  limitName: string;
  limitDescription: string;
  onUpdate: () => Promise<ApolloQueryResult<EntityQuery>>;
};

const EntityRateLimitInput = ({
  originalLimit,
  entityName,
  limitTitle,
  limitName,
  limitDescription,
  onUpdate,
}: EntityRateLimitInputProps) => {
  const [updateEntityAdmin, {loading}] = useUpdateEntityAdminMutation();

  const [newLimit, setNewLimit] = useState(originalLimit.toString());

  return (
    <Tailwind>
      <Input
        size="mini"
        type="number"
        className="mb-8 mr-12"
        value={newLimit}
        onChange={(_, {value}) => setNewLimit(value)}
        label={{
          content: (
            <div className="flex items-center justify-between">
              <span className="w-20 font-semibold">{limitTitle}</span>
              <Tooltip
                position="top center"
                trigger={
                  <div className="ml-5">
                    <Icon color="gray" name="info" />
                  </div>
                }>
                {limitDescription}
              </Tooltip>
            </div>
          ),
          style: {width: '200px'},
        }}
        action={{
          content: 'Save',
          size: 'mini',
          disabled: newLimit === originalLimit.toString() || loading,
          onClick: async () => {
            try {
              await updateEntityAdmin({
                variables: {
                  entityName: entityName ?? '',
                  rateLimits: {[limitName]: Number(newLimit)},
                },
              });
              setNewLimit(originalLimit.toString());
              toast(`successfully updated ${limitTitle} rate limit`);
              onUpdate();
            } catch (e) {
              console.error(e);
              toast(`error updating ${limitTitle} rate limit`, {type: 'error'});
            }
          },
        }}
      />
    </Tailwind>
  );
};

export default EntityRateLimitInput;
